<template>
  <div class="animated fadeIn">
    <basic-heading title="Testing Workflow" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="['list sample type', 'list test process']">
      <template #gated-content>
        <WorkflowTestServerTable />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate'
import WorkflowTestServerTable from '@/components/lab/workflows/test/WorkflowTestServerTable'

export default {
  name: 'WorkflowTestIndex',
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    WorkflowTestServerTable
  },
  computed: {
    button_config () {
      return {
        buttons: [
        ]
      }
    }
  }
}
</script>
